import React from 'react'

export interface SpaceBetweenProps {
  children?: React.ReactNode
  size?: 'xxxs' | 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl' | Record<string, string>
  direction?: 'vertical' | 'horizontal'
  alignItems?: 'start' | 'center' | 'end'
  className?: string
  style?: React.CSSProperties
}

const sizeMap = {
  xxxs: '2px',
  xxs: '4px',
  xs: '8px',
  s: '12px',
  m: '16px',
  l: '24px',
  xl: '32px',
  xxl: '40px',
}

export const SpaceBetween: React.FC<SpaceBetweenProps> = ({
  children,
  size = 'm',
  direction = 'vertical',
  alignItems,
  className,
  style,
}) => {
  const spaceBetweenStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: direction === 'vertical' ? 'column' : 'row',
    gap: typeof size === 'string' ? sizeMap[size] : undefined,
    alignItems: alignItems,
    ...style,
  }

  return (
    <div className={className} style={spaceBetweenStyle}>
      {children}
    </div>
  )
}
